import { queryOptions } from '@tanstack/react-query';

import { ONE_HOUR } from '@/constants/time';
import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

type GetContentLibraryItemV2Params =
  paths['/v2/content-library-items/{contentLibraryItemId}']['get']['parameters']['path'];

export type GetContentLibraryItemV2Response =
  paths['/v2/content-library-items/{contentLibraryItemId}']['get']['responses'][200]['content']['application/json']['data'];

export async function getContentLibraryItemV2({
  contentLibraryItemId,
}: GetContentLibraryItemV2Params): Promise<GetContentLibraryItemV2Response> {
  const { data } = await fetchClient.GET('/v2/content-library-items/{contentLibraryItemId}', {
    params: { path: { contentLibraryItemId } },
  });

  return data?.data;
}

export function getContentLibraryItemV2QueryOptions(params: GetContentLibraryItemV2Params) {
  return queryOptions({
    queryKey: ['contentLibraryItemV2', params.contentLibraryItemId],
    queryFn: () => getContentLibraryItemV2(params),
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
  });
}
